import Vue from 'vue';
import VueRouter from 'vue-router';

    Vue.use(VueRouter);

import Success from "../pages/Success.vue";
import TravelData from "../pages/TravelData.vue";
import UserData from "../pages/UserData.vue";

const routes = [
    {
        name: 'travelData',
        path: '/',
        component: TravelData,
    },
    {
        name: 'userData',
        path: '/user-data',
        component: UserData,
    },
    {
        name: 'success',
        path: '/success',
        component: Success,
    },
];
export const router = new VueRouter({
    routes,
    linkActiveClass: "active",
    linkExactActiveClass: "exact-active",
});
